function consoleLog(...theArgs: any) {
  if (process.env.REACT_APP_ENV === 'development')
    return console.log(...theArgs)
}

export default consoleLog
